/**
 * Utilitários de urgência para tickets.
 *
 * Urgência é o campo visível ao usuário comum ao abrir um chamado.
 * Valores aceitos: 'ALTA' | 'MEDIA' | 'BAIXA' — exatamente esses 3.
 */

export type TicketUrgency = 'ALTA' | 'MEDIA' | 'BAIXA';

export const URGENCY_OPTIONS: { value: TicketUrgency; label: string }[] = [
  { value: 'ALTA',  label: 'Alta'  },
  { value: 'MEDIA', label: 'Média' },
  { value: 'BAIXA', label: 'Baixa' },
];

const URGENCY_COLORS: Record<TicketUrgency, string> = {
  ALTA:  'danger',   // vermelho
  MEDIA: 'warning',  // laranja
  BAIXA: 'success',  // verde
};

const URGENCY_LABELS: Record<TicketUrgency, string> = {
  ALTA:  'Alta',
  MEDIA: 'Média',
  BAIXA: 'Baixa',
};

export function getUrgencyColor(urgency: string | undefined | null): string {
  if (!urgency) return 'secondary';
  return URGENCY_COLORS[urgency as TicketUrgency] ?? 'secondary';
}

export function getUrgencyLabel(urgency: string | undefined | null): string {
  if (!urgency) return '—';
  return URGENCY_LABELS[urgency as TicketUrgency] ?? urgency;
}

export function isValidUrgency(value: string): value is TicketUrgency {
  return ['ALTA', 'MEDIA', 'BAIXA'].includes(value);
}
